export var ALIGNMENTS = ['top', 'bottom', 'start', 'end', 'center'];
export var POSITIONS = ['above', 'below', 'before', 'after'];
export var AUTOSIZES = ['height', 'height-always', 'width', 'width-always', 'always', true, false];